// Tandem AI Tool Set base — same cross-reference pattern as WorkspaceAIToolSet / CommitMessageAIToolSet

import { AIToolSet } from "../../../base/AIToolSet.js";

export class TandemAIToolSet extends AIToolSet {}
